"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateLandingPage = exports.UpdateLandingPageActionTypes = exports.FetchLandingPagesByLanguageContent = exports.FetchLandingPagesByLanguageContentActionTypes = exports.FetchLandingPagesByNameQuery = exports.FetchLandingPagesByNameQueryActionTypes = exports.FetchLandingPagesByIds = exports.FetchLandingPagesByIdsActionTypes = exports.updateLandingPage = exports.fetchLandingPagesByLanguageContent = exports.fetchLandingPagesByIds = exports.debouncedFetchLandingPagesByNameQuery = exports.LandingPagesActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _constants = require("./constants");

var LandingPagesActionTypes = (0, _namespacedKeyMirror.default)({
  DEBOUNCED_FETCH_LANDING_PAGES_BY_NAME_QUERY: null,
  FETCH_LANDING_PAGES_BY_IDS: null,
  FETCH_LANDING_PAGES_BY_NAME_QUERY: null,
  FETCH_LANDING_PAGES_BY_LANGUAGE_CONTENT: null,
  UPDATE_LANDING_PAGE: null
}, _constants.LANDING_PAGES);
exports.LandingPagesActionTypes = LandingPagesActionTypes;
var debouncedFetchLandingPagesByNameQuery = (0, _fluxActions.createAction)(LandingPagesActionTypes.DEBOUNCED_FETCH_LANDING_PAGES_BY_NAME_QUERY, (0, _actions.mapPayloadTo)('searchId', 'nameQuery'));
exports.debouncedFetchLandingPagesByNameQuery = debouncedFetchLandingPagesByNameQuery;
var fetchLandingPagesByIds = (0, _fluxActions.createAction)(LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_IDS, (0, _actions.mapPayloadTo)('ids'));
exports.fetchLandingPagesByIds = fetchLandingPagesByIds;
var fetchLandingPagesByLanguageContent = (0, _fluxActions.createAction)(LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_LANGUAGE_CONTENT, (0, _actions.mapPayloadTo)('domain', 'language'));
exports.fetchLandingPagesByLanguageContent = fetchLandingPagesByLanguageContent;
var updateLandingPage = (0, _fluxActions.createAction)(LandingPagesActionTypes.UPDATE_LANDING_PAGE, function (data) {
  return data;
});
exports.updateLandingPage = updateLandingPage;
var FetchLandingPagesByIdsActionTypes = (0, _actions.createRequestTypes)(LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_IDS);
exports.FetchLandingPagesByIdsActionTypes = FetchLandingPagesByIdsActionTypes;
var FetchLandingPagesByIds = (0, _actions.createRequestActions)(FetchLandingPagesByIdsActionTypes, {
  keys: ['ids']
});
exports.FetchLandingPagesByIds = FetchLandingPagesByIds;
var FetchLandingPagesByNameQueryActionTypes = (0, _actions.createRequestTypes)(LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_NAME_QUERY);
exports.FetchLandingPagesByNameQueryActionTypes = FetchLandingPagesByNameQueryActionTypes;
var FetchLandingPagesByNameQuery = (0, _actions.createRequestActions)(FetchLandingPagesByNameQueryActionTypes, {
  keys: ['searchId']
});
exports.FetchLandingPagesByNameQuery = FetchLandingPagesByNameQuery;
var FetchLandingPagesByLanguageContentActionTypes = (0, _actions.createRequestTypes)(LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_LANGUAGE_CONTENT);
exports.FetchLandingPagesByLanguageContentActionTypes = FetchLandingPagesByLanguageContentActionTypes;
var FetchLandingPagesByLanguageContent = (0, _actions.createRequestActions)(FetchLandingPagesByLanguageContentActionTypes, {
  keys: ['domain', 'language']
});
exports.FetchLandingPagesByLanguageContent = FetchLandingPagesByLanguageContent;
var UpdateLandingPageActionTypes = (0, _actions.createRequestTypes)(LandingPagesActionTypes.UPDATE_LANDING_PAGE);
exports.UpdateLandingPageActionTypes = UpdateLandingPageActionTypes;
var UpdateLandingPage = (0, _actions.createRequestActions)(UpdateLandingPageActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateLandingPageActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.pages.notifications.landingPages.success')));
  },
  failureMetaCreator: function failureMetaCreator(_ref) {
    var responseJSON = _ref.responseJSON;

    var defaultMessage = _I18n.default.text('marketing.pages.notifications.landingPages.error');

    var errorMessage = responseJSON && responseJSON.message ? responseJSON.message : defaultMessage;
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateLandingPageActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(errorMessage));
  }
});
exports.UpdateLandingPage = UpdateLandingPage;